import { getPatientTranslation } from "@/i18n-for-patient"
import { Language } from "@/types/__generated__/union-types"

const getPrefilledTranslations = (language: Language = "GERMAN") => {
  const { prefilledTranslations } = getPatientTranslation(language).documents.generalAttestation
  return {
    to: prefilledTranslations.to,
    message: prefilledTranslations.message,
    subject: prefilledTranslations.subject,
  }
}

export { getPrefilledTranslations }
